<template>
  <div class="webinar">
    <h3>{{title}}</h3>
    <JourneyMedia v-if="media" :media="media"/>
    <div class="description" v-html="description"></div>
    <button
    class="link-button"
    v-if="link"
    @click="openWebinar"
    @keyup.enter="openWebniar">
      {{buttonText}}
       <RightArrow
      :opacity="1"
      fill="white">
      </RightArrow>
    </button>
  </div>
</template>

<style lang="less" scoped>
@import "./shared.less";
.webinar {
  button {
    background: gray;
    color: white;
    cursor: pointer;
    &:hover{
      background: lighten(gray, 10%);
    }
  }
}
</style>

<script>
import { mapActions } from "vuex";
import RightArrow from "@/common/icons/RightArrow"
import JourneyMedia from "./JourneyMedia";

export default {
  components: {RightArrow, JourneyMedia},
  props: {
    description: {
      type: String
    },
    title: {
      type: String
    },
    link: {
      type: String,
    },
    started: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String
    },
    media: {
      type: Object,
    },
  },
  methods: {
    openWebinar() {
      if (this.started) {
        window.open(this.link, "_blank");
      } else {
        this.promptStartJourney();
      }
    }
  },
  ...mapActions(["promptStartJourney"])
}
</script>